import { render, staticRenderFns } from "./ChooseUserType.vue?vue&type=template&id=20e96bb8&"
import script from "./ChooseUserType.vue?vue&type=script&lang=js&"
export * from "./ChooseUserType.vue?vue&type=script&lang=js&"
import style0 from "./ChooseUserType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports